import { render, staticRenderFns } from "./gl.vue?vue&type=template&id=80b862d0&scoped=true"
import script from "./gl.vue?vue&type=script&lang=js"
export * from "./gl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b862d0",
  null
  
)

export default component.exports